export default {
  token: null,
  totem: {},
  erros: [],
  afk: false,
};
